import { Component, OnInit, Input } from '@angular/core';
import { GraphqlService } from '../../services/graphql.service';

@Component({
  selector: 'app-scroll-to-top',
  templateUrl: './scroll-to-top.component.html',
  styleUrls: ['./scroll-to-top.component.css']
})
export class ScrollToTopComponent implements OnInit {
  backToTop: string = "";
  @Input() windowScrolled: boolean = true
  constructor(
    private graphQlService: GraphqlService,) { }
  ngOnInit() {
    this.graphQlService.getGlobalLabels().subscribe(data => {
      if (data != "") {
        let labels = data.content.data.labels;
        labels = labels.filter(x => x.key.trim());
        this.backToTop = labels.filter(x => x.key == "backToTop").map(y => y.value)[0];
      }
    });
  }
  scrollToTop() {
    document.getElementsByTagName('app-main-content')[0].scrollTop = 0;
  }

}
